module.exports = __webpack_public_path__ + "img/2_diamonds_star.3080760f.png";